// This file is auto-generated from Protocol.kt
// DO NOT EDIT MANUALLY - Run './gradlew generateTypeScript' to regenerate

import { z } from 'zod';

export const PlayerRoleSchema = z.enum([
    "player",
    "spectator"
]);
export type PlayerRole = z.infer<typeof PlayerRoleSchema>;

export const PromptModeSchema = z.enum([
    "physical",
    "digital"
]);
export type PromptMode = z.infer<typeof PromptModeSchema>;


export const GameSettingsDataSchema = z.object({
    allowArticleReshuffle: z.boolean(),
    articlesPerPlayer: z.number(),
    maxReshuffles: z.number(),
    promptMode: PromptModeSchema,
    repickArticlesEachRound: z.boolean(),
    timerDurationSeconds: z.number()
});
export type GameSettingsData = z.infer<typeof GameSettingsDataSchema>;

export const PlayerInfoSchema = z.object({
    id: z.string(),
    isConnected: z.boolean().optional(),
    isHost: z.boolean(),
    name: z.string(),
    role: PlayerRoleSchema.optional()
});
export type PlayerInfo = z.infer<typeof PlayerInfoSchema>;

export const CommonRoomDataSchema = z.object({
    phaseStartTime: z.number().nullable().optional(),
    players: z.array(PlayerInfoSchema),
    roomCode: z.string(),
    round: z.number(),
    settings: GameSettingsDataSchema,
    timeoutTime: z.number().nullable().optional(),
    totalRounds: z.number().nullable()
});
export type CommonRoomData = z.infer<typeof CommonRoomDataSchema>;

export const ArticleInfoSchema = z.object({
    attribution: z.string(),
    title: z.string(),
    url: z.string()
});
export type ArticleInfo = z.infer<typeof ArticleInfoSchema>;

export const ResultEntrySchema = z.object({
    answer: z.string().nullable(),
    article: ArticleInfoSchema.nullable(),
    playerName: z.string()
});
export type ResultEntry = z.infer<typeof ResultEntrySchema>;

export const DigitalPromptEntryViewSchema = z.object({
    type: z.literal("digital_prompt_entry"),
    cardCount: z.number(),
    currentRound: z.number(),
    pickedIndex: z.number().nullable().optional(),
    picker: PlayerInfoSchema.nullable(),
    promptText: z.string().nullable().optional()
});
export type DigitalPromptEntryView = z.infer<typeof DigitalPromptEntryViewSchema>;

export const GameOverViewSchema = z.object({
    type: z.literal("game_over"),
    finalScores: z.record(z.string(), z.number())
});
export type GameOverView = z.infer<typeof GameOverViewSchema>;

export const PromptEntryViewSchema = z.object({
    type: z.literal("prompt_entry"),
    currentRound: z.number(),
    picker: PlayerInfoSchema.nullable(),
    promptText: z.string().nullable().optional()
});
export type PromptEntryView = z.infer<typeof PromptEntryViewSchema>;

export const ResultsViewSchema = z.object({
    type: z.literal("results"),
    entries: z.array(ResultEntrySchema),
    highlightedIndex: z.number(),
    isPresenter: z.boolean(),
    presenterName: z.string(),
    prompt: z.string()
});
export type ResultsView = z.infer<typeof ResultsViewSchema>;

export const RoundLeaderboardViewSchema = z.object({
    type: z.literal("round_leaderboard"),
    roundResults: z.record(z.string(), z.number()),
    scores: z.record(z.string(), z.number())
});
export type RoundLeaderboardView = z.infer<typeof RoundLeaderboardViewSchema>;

export const SelectArticleViewSchema = z.object({
    type: z.literal("select_article"),
    articles: z.array(ArticleInfoSchema),
    awaitingPlayers: z.array(PlayerInfoSchema),
    isWaiting: z.boolean(),
    prompt: z.string(),
    reshuffleAvailable: z.boolean().optional(),
    selectedArticle: ArticleInfoSchema.nullable()
});
export type SelectArticleView = z.infer<typeof SelectArticleViewSchema>;

export const VotingResultsViewSchema = z.object({
    type: z.literal("voting_results"),
    answers: z.record(z.string(), z.string().nullable()),
    results: z.record(z.string(), z.number())
});
export type VotingResultsView = z.infer<typeof VotingResultsViewSchema>;

export const VotingViewSchema = z.object({
    type: z.literal("voting"),
    awaitingPlayers: z.array(PlayerInfoSchema),
    entries: z.record(z.string(), z.string().nullable()),
    hasVoted: z.boolean()
});
export type VotingView = z.infer<typeof VotingViewSchema>;

export const WaitingRoomViewSchema = z.object({
    type: z.literal("waiting_room"),
    isHost: z.boolean(),
    minPlayersMet: z.boolean(),
    settings: GameSettingsDataSchema
});
export type WaitingRoomView = z.infer<typeof WaitingRoomViewSchema>;

export const WordPickerViewSchema = z.object({
    type: z.literal("word_picker"),
    article: ArticleInfoSchema.nullable(),
    awaitingPlayers: z.array(PlayerInfoSchema),
    isWaiting: z.boolean(),
    prompt: z.string(),
    words: z.array(z.string())
});
export type WordPickerView = z.infer<typeof WordPickerViewSchema>;

export const PhaseViewSchema = z.discriminatedUnion("type", [
    DigitalPromptEntryViewSchema,
    GameOverViewSchema,
    PromptEntryViewSchema,
    ResultsViewSchema,
    RoundLeaderboardViewSchema,
    SelectArticleViewSchema,
    VotingResultsViewSchema,
    VotingViewSchema,
    WaitingRoomViewSchema,
    WordPickerViewSchema
]);
export type PhaseView = z.infer<typeof PhaseViewSchema>;


export const ServerboundAdvanceResultsSchema = z.object({
    type: z.literal("advance_results"),
});
export type ServerboundAdvanceResults = z.infer<typeof ServerboundAdvanceResultsSchema>;

export const ServerboundCastVoteSchema = z.object({
    type: z.literal("cast_vote"),
    playerId: z.string()
});
export type ServerboundCastVote = z.infer<typeof ServerboundCastVoteSchema>;

export const ServerboundJoinRoomSchema = z.object({
    type: z.literal("join_room"),
    playerName: z.string()
});
export type ServerboundJoinRoom = z.infer<typeof ServerboundJoinRoomSchema>;

export const ServerboundKickPlayerSchema = z.object({
    type: z.literal("kick_player"),
    playerId: z.string()
});
export type ServerboundKickPlayer = z.infer<typeof ServerboundKickPlayerSchema>;

export const ServerboundPickPromptCardSchema = z.object({
    type: z.literal("pick_prompt_card"),
    index: z.number()
});
export type ServerboundPickPromptCard = z.infer<typeof ServerboundPickPromptCardSchema>;

export const ServerboundRejoinRoomSchema = z.object({
    type: z.literal("rejoin_room"),
    rejoinToken: z.string()
});
export type ServerboundRejoinRoom = z.infer<typeof ServerboundRejoinRoomSchema>;

export const ServerboundReshuffleArticlesSchema = z.object({
    type: z.literal("reshuffle_articles"),
});
export type ServerboundReshuffleArticles = z.infer<typeof ServerboundReshuffleArticlesSchema>;

export const ServerboundReturnToLobbySchema = z.object({
    type: z.literal("return_to_lobby"),
});
export type ServerboundReturnToLobby = z.infer<typeof ServerboundReturnToLobbySchema>;

export const ServerboundSelectArticleSchema = z.object({
    type: z.literal("select_article"),
    index: z.number()
});
export type ServerboundSelectArticle = z.infer<typeof ServerboundSelectArticleSchema>;

export const ServerboundStartGameSchema = z.object({
    type: z.literal("start_game"),
    allowArticleReshuffle: z.boolean().optional(),
    articlesPerPlayer: z.number().min(2).max(5).optional(),
    maxReshuffles: z.number().min(0).max(10).optional(),
    promptMode: PromptModeSchema.optional(),
    repickArticlesEachRound: z.boolean().optional(),
    timerDurationSeconds: z.union([z.literal(30), z.literal(60), z.literal(120), z.literal(180), z.literal(300)]).optional(),
    totalRounds: z.number().min(1).nullable().optional()
});
export type ServerboundStartGame = z.infer<typeof ServerboundStartGameSchema>;

export const ServerboundSubmitAnswerSchema = z.object({
    type: z.literal("submit_answer"),
    answer: z.array(z.string())
});
export type ServerboundSubmitAnswer = z.infer<typeof ServerboundSubmitAnswerSchema>;

export const ServerboundSubmitPromptCodeSchema = z.object({
    type: z.literal("submit_prompt_code"),
    code: z.string()
});
export type ServerboundSubmitPromptCode = z.infer<typeof ServerboundSubmitPromptCodeSchema>;

export const ServerboundTransferHostSchema = z.object({
    type: z.literal("transfer_host"),
    playerId: z.string()
});
export type ServerboundTransferHost = z.infer<typeof ServerboundTransferHostSchema>;

export const ServerboundUpdateAnswerSchema = z.object({
    type: z.literal("update_answer"),
    answer: z.array(z.string())
});
export type ServerboundUpdateAnswer = z.infer<typeof ServerboundUpdateAnswerSchema>;

export const ServerboundWatchRoomSchema = z.object({
    type: z.literal("watch_room"),
});
export type ServerboundWatchRoom = z.infer<typeof ServerboundWatchRoomSchema>;

export const ServerboundMessageSchema = z.discriminatedUnion("type", [
    ServerboundAdvanceResultsSchema,
    ServerboundCastVoteSchema,
    ServerboundJoinRoomSchema,
    ServerboundKickPlayerSchema,
    ServerboundPickPromptCardSchema,
    ServerboundRejoinRoomSchema,
    ServerboundReshuffleArticlesSchema,
    ServerboundReturnToLobbySchema,
    ServerboundSelectArticleSchema,
    ServerboundStartGameSchema,
    ServerboundSubmitAnswerSchema,
    ServerboundSubmitPromptCodeSchema,
    ServerboundTransferHostSchema,
    ServerboundUpdateAnswerSchema,
    ServerboundWatchRoomSchema
]);
export type ServerboundMessage = z.infer<typeof ServerboundMessageSchema>;


export const ClientboundEventSchema = z.object({
    type: z.literal("event"),
    data: z.record(z.string(), z.string()).optional(),
    eventType: z.string()
});
export type ClientboundEvent = z.infer<typeof ClientboundEventSchema>;

export const ClientboundJoinRoomSchema = z.object({
    type: z.literal("join_room"),
    rejoinToken: z.string(),
    roomId: z.string()
});
export type ClientboundJoinRoom = z.infer<typeof ClientboundJoinRoomSchema>;

export const ClientboundSnapshotSchema = z.object({
    type: z.literal("snapshot"),
    phase: z.string(),
    room: CommonRoomDataSchema,
    self: PlayerInfoSchema,
    view: PhaseViewSchema
});
export type ClientboundSnapshot = z.infer<typeof ClientboundSnapshotSchema>;

export const ClientboundTvSnapshotSchema = z.object({
    type: z.literal("tv_snapshot"),
    phase: z.string(),
    room: CommonRoomDataSchema,
    view: PhaseViewSchema
});
export type ClientboundTvSnapshot = z.infer<typeof ClientboundTvSnapshotSchema>;

export const ClientboundMessageSchema = z.discriminatedUnion("type", [
    ClientboundEventSchema,
    ClientboundJoinRoomSchema,
    ClientboundSnapshotSchema,
    ClientboundTvSnapshotSchema
]);
export type ClientboundMessage = z.infer<typeof ClientboundMessageSchema>;

